<template>
  <v-container class="pa-0 ma-0">
    <div class="d-flex justify-space-around justify-center font-weight-bold text--darken-4 my-4">{{$t('lang.query')}}</div>
    <v-row class="d-flex justify-space-around justify-center">
      <v-col cols="12" sm="12">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.registrationNumber')}}</td>
                <td class="grey--text text--darken-2 text-subtitle-1">{{obj.SignUpNo}}</td>
              </tr>
              <tr>
                <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.participant')}}</td>
                <td class="grey--text text--darken-2 text-subtitle-1">{{obj.UserName}}</td>
              </tr>
              <tr>
                <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.registrationPhoneOrEmail')}}</td>
                <td class="grey--text text--darken-2 text-subtitle-1">{{obj.Phone}}</td>
              </tr>
              <tr v-if="obj.MemberList && obj.MemberList.length > 1">
                <td class="black--text text--darken-2 text-subtitle-1">同一单位多人报名</td>
                <td class="grey--text text--darken-2 text-subtitle-1">是
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    :hide-default-footer="true"
                    no-data-text=""
                  ></v-data-table>
                </td>
              </tr>
              <tr v-for="(customItem, i) in obj.CustomItemList" :key="i">
                <td class="black--text text--darken-2 text-subtitle-1">{{customItem.ItemName}}</td>
                <td v-if="!((customItem.ItemType === 1 && customItem.ItemRule === 6) || customItem.ItemType === 6)" class="grey--text text--darken-2 text-subtitle-1">{{customItem.Content}}</td>
                <td v-if="customItem.ItemType === 6" class="grey--text text--darken-2 text-subtitle-1">
                  <van-image fit="cover" lazy-load height="120" width="120" :src="customItem.Content"></van-image>
                </td>
                <td v-if="customItem.ItemType === 1 && customItem.ItemRule === 6" class="grey--text text--darken-2 text-subtitle-1">{{location(customItem.Content)}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <div class="d-flex justify-space-around justify-center">
      <v-btn color="primary" style="text-transform:none;" @click="$emit('fatherEvent', 'back')">{{$t('lang.back')}}</v-btn>
    </div>
    <v-snackbar v-model="snackbar" timeout="2000" centered color="primary" multi-line>
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('lang.close')}}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
export default {
  name: 'Preview',
  props: ['data'],
  computed: {
    state () {
      let state = ''
      switch (this.obj.State) {
        case 1:
          state = '待审'
          break
        case 2:
          state = '通过'
          break
        case 3:
          state = '未通过'
          break
        case 4:
          state = '已导入'
          break
        case 5:
          state = '已支付'
          break
        default:
          break
      }
      return state
    },
    payState () {
      let state = ''
      switch (this.obj.PayState) {
        case 1:
          state = '未缴费'
          break
        case 2:
          state = '微信已缴'
          break
        case 3:
          state = '转账已缴'
          break
        case 4:
          state = '其它已缴'
          break
        case 5:
          state = '已开发票'
          break
        case 6:
          state = '已退费'
          break
        default:
          break
      }
      return state
    }
  },
  data () {
    return {
      snackbar: false,
      msg: '',
      obj: {},
      desserts: [],
      headers: [
        {
          text: '编号',
          align: 'start',
          value: 'num',
          sortable: false
        },
        { text: '参会人姓名', value: 'name', sortable: false },
        { text: '参会人电话/邮箱', value: 'phone', sortable: false }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.$http.get('/SignUp/GetUserSignupInfo', {
        requestBase: 'VUE_APP_API',
        params: {
          input: this.$store.getters.getUserSignUpId
        }
      }).then(res => {
        if (res.data.ret === 0) {
          console.log(res)
          this.obj = res.data.data
          if (this.obj.MemberList) {
            this.setMemberList()
          }
        } else {
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        this.msg = 'error'
        this.snackbar = true
        console.log(e)
      })
    },
    location (val) {
      return val.split('í')[4] ? val.split('í')[4] : val.split('í')[1] + val.split('í')[2]
    },
    setMemberList () {
      for (let index = 0; index < this.obj.MemberList.length; index++) {
        const element = this.obj.MemberList[index]
        this.desserts.push({
          num: index + 1,
          name: element.TrueName,
          phone: element.Phone || element.Email
        })
      }
    }
  }
}
</script>
